import { useEffect, useRef } from 'react'

export function useApiAbortController() {
  const abortControllerRef = useRef(null)

  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort()

      abortControllerRef.current = null
    }
  }, [])

  return abortControllerRef
}
